import React from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Title from '../../../components/Title';
import Block from '../../../components/Block';
import ShowItem from '../../../components/ShowItem';
import * as Format from "../../../components/Format";
import {Icon} from "../../../components/components";
import {Button} from "react-bootstrap";
import useActionConfirmation from "../../../components/useActionConfirmation";
import {useDeleteUserMutation, useGetUserQuery} from "../../../api/userApiSlice";

export default function PublisherUser(props) {
  const { t } = useTranslation();
  const { userId } = useParams();
  const {data: user, isSuccess} = useGetUserQuery(userId)
  const [deleteUser] = useDeleteUserMutation()
  const history = useHistory();
  const rolePrefix = "publisher_"

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleDelete = function() {
    deleteUser(userId).unwrap()
      .then(() => {
        history.push(`/users`);
      })
  }

  if (!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} backPath="/users">
        <Button onClick={() => history.push(`/users/${userId}/edit`)}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
        <Button onClick={() => confirm(handleDelete, user.lastName)}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
      </Title>
      <Block>
        <ShowItem label={t("users.firstName")} value={user.firstName} />
        <ShowItem label={t("users.lastName")} value={user.lastName} />
        <ShowItem label={t("users.email")} value={user.email} />
        <ShowItem label={t("users.phoneNumber")} value={user.phoneNumber} />
        <ShowItem label={t("users.createdAt")}>
          <Format.Date date={user.createdAt} />
        </ShowItem>
        <ShowItem label={t("users.roles")} array value={user.roles.map(role => t("user."+role.replace(rolePrefix, '')))}/>
        <ShowItem label={t("users.subscribedToSdkVersionNewsletter")} value={user.subscribedToSdkVersionNewsletter == true ? t('true') : t('false') }/>
      </Block>
      <Confirmation placeholder="Please enter user last name" {...confirmationProps} deletion />
    </>
  )
}




